import axios from "axios";
import Config from "src/config";

const v1_actionWboTemplates = (canalId) => {
    // canalId é o cliente_id do canal WhatsApp Business
    const url = `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v1/${canalId}/canais/wbo/templates`;
    
    return axios({
        method: "get",
        url: url
    });
};

export default v1_actionWboTemplates;
